import { logger } from '@pkg/logger';

export const copyToClipboard = async(text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    logger.debug('Content copied to clipboard:', text);
    /* Resolved - text copied to clipboard successfully */
  } catch (err) {
    logger.error('Failed to copy: ', err);
    /* Rejected - text failed to copy to the clipboard */
  }
};
